import { VideoPlayer } from './videoPlayer.jsx';

const props = [
    'videoUrl'
    , 'posterImageUrl'
    , 'adUrlTemplate'
    , 'adPageId'
    , 'adPositionId'
    , 'platformCode'
    , 'videoSources'
    , 'playlist'
    , 'playlistNextCallback'
    , 'adUrl'
    , 'adClient'
];

export const VideoPlayerDirective = reactDirective => reactDirective(VideoPlayer, props);
VideoPlayerDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('videoPlayer', VideoPlayerDirective);
